import { eAuthorType } from './eAuthorTypes';
import { eCommentType } from './eCommentType';

export interface ICommentResponse {
  id: string;
  type?: eCommentType;
  content: string;
  createdAt: string;
  updatedAt: string;
  author: {
    id: string;
    type: eAuthorType;
    fullName: string;
  };
  relevantParty?: eAuthorType;
  vendorCompany?: string;
}

export type ICommentData = ICommentResponse;

export const convertICommentResponseToICommentData = ({
  id,
  type,
  content,
  createdAt,
  updatedAt,
  author,
  vendorCompany,
}: ICommentResponse): ICommentData => {
  return {
    id,
    type,
    content,
    createdAt,
    updatedAt,
    author,
    vendorCompany,
  };
};

export const mockCommentResponse = (overrides?: Partial<ICommentResponse>): ICommentResponse => ({
  id: overrides?.id ?? '8616ce7e-3fee-4493-bc50-69db5a103baf',
  type: overrides?.type ?? eCommentType.general,
  content: overrides?.content ?? 'content',
  createdAt: overrides?.createdAt ?? '01-01-24',
  updatedAt: overrides?.updatedAt ?? '01-01-24',
  author: overrides?.author ?? {
    id: 'c9544ccd-bd41-4168-a6d9-c654aa3eb8b6',
    type: eAuthorType.Admin,
    fullName: 'Abraham Lincoln',
  },
});
